import { create } from 'zustand';
import { TToastProps, TToastStore } from './ToastStore.types';

const initalState = {
	message: '',
	variant: 'success' as TToastProps['variant'],
};

export const useToastStore = create<TToastStore>((set) => ({
	toastProps: initalState,
	setToast: ({ message, variant }: TToastProps) => set({ toastProps: { message, variant } }),
}));
